class Part {

  get options() {
    return {};
  }

  constructor(section) {
    this.section = section;
    this.calculator = section.calculator;
    this.form = this.calculator.form;
    this.cost = 0;
    this.value = '';

    this.el = this.processPart();
    this.el.addClass('catcalc--part');

    this.subtotalEl = this.form.find('.catcalc-' + this.section.constructor.name.toLowerCase() + '-' + this.constructor.name.toLowerCase() + '-cost input');

    this.summaryEl = this.form.find('.catcalc--summary-' + this.section.constructor.name.toLowerCase() + '-' + this.constructor.name.toLowerCase());

    this.label = this.el.find('label.gfield_label');
    this.label.on('click touch', function () {
      $(this).next('.ginput_container').slideToggle();
    });

    this.label.append($('label.part-estimate'));

    console.log(this.label);
    this.field = this.el.find('input');

    this.field.on('change', (e) => {

      this.el.find('.ginput_container').slideUp();

      this.value = '';

      let value = $(e.currentTarget).val()

      if (value) {
        this.value = value.toLowerCase();
        let option = this.options[this.value];

        if (option) {
          this.cost = option.price;
          this.subtotalEl.val(this.total());
          this.summaryEl.find('.choice').html(value);
          this.summaryEl.find('.cost').html("$" + this.total());
          this.form.trigger('catcalc.change');
        }
      }
    });

    this.render();

  }

  processPart() {
    return this.form.find('.catcalc-' + this.section.constructor.name.toLowerCase() + '-' + this.constructor.name.toLowerCase())
  }

  total() {
    //default to per person cost
    return this.perPerson(this.cost);
  }

  perPerson(cost) {
    return this.calculator.event.guests * cost;
  }

  events() {

  }

  render() {
    this.field.each((index, field) => {

      if(field) {
        let $field = $(field);
        let $gfield = $(field).parent('li');
        let option = this.options[$field.val().toLowerCase()];

        $gfield.addClass($field.val().toLowerCase().replace(' ','-'));

        if(option && option.description) {
          $gfield.addClass('option');
          option.title = $gfield.find('label').html();
          $gfield.find('label').html(`
                <span class="option-title">${option.title}</span>
                <p class="option-description">
                  ${option.description}
                </p>
                <span class="option-pricing">
                                    $${this.renderPrice(option)}
                  <em>/pp</em>
                </span>
            `);
        }

      }



    });


  }

  renderPrice(option) {
    return option.price;
  }
}

export default Part



// WEBPACK FOOTER //
// ./scripts/catcalc/part.js